module.exports = __webpack_public_path__ + "img/percent-icon.eeffd84e.svg";